import { useAuthStore } from "..";
import { showErrorToast } from "../components/ToastContainer";

const useSetNewPassword = (): (email: string, password: string, resetToken: string) => Promise<void> => {
    const authStore = useAuthStore();

    return async (email: string, password: string, resetToken: string): Promise<void> => {
        try {
            await authStore.setNewPassword(email, password, resetToken);
        } catch (e) {
            showErrorToast();
            throw e;
        }
    };
};

export default useSetNewPassword;